import React from 'react';
import { useSEO } from '../context/SEOContext';

const StructuredData = () => {
  const { seoSettings } = useSEO();

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": seoSettings.siteTitle,
    "description": seoSettings.siteDescription,
    "url": window.location.origin,
    "inLanguage": "tr-TR",
    "publisher": {
      "@type": "Organization",
      "name": seoSettings.siteTitle,
      "logo": {
        "@type": "ImageObject",
        "url": seoSettings.logo || `${window.location.origin}/logo.png`
      }
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${window.location.origin}/search?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Ana Sayfa",
        "item": window.location.origin
      }
    ]
  };

  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": seoSettings.siteTitle,
    "description": seoSettings.siteDescription,
    "url": window.location.origin,
    "logo": seoSettings.logo || `${window.location.origin}/logo.png`,
    "sameAs": []
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationData) }}
      />
    </>
  );
};

export default StructuredData;
